
// SVG Icon: close
export default { id: "terriajs-close" };
export const id = "terriajs-close";
export const name = "close";
